import packageJson from '../../../package.json';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>v{packageJson.version}</p>
    </footer>
  );
};

export default Footer;
